import currencyFormatter from 'currency-formatter';
import PropTypes from 'prop-types';
import React from 'react';
import {Trans} from 'react-i18next';
import './Price.scss';

interface IProps {
  price: number;
  currency: string;
  translationKey: string;
  priceKey?: string;
}

export const Price: React.FunctionComponent<IProps> = (props) => {
  const {price, priceKey = 'price', currency, translationKey} = props;
  const formattedPrice = currencyFormatter.format(price, {code: currency});
  const priceArgs = {
    [priceKey]: `${formattedPrice}`,
  };

  return (
    <span data-hook="currency" className={currency}>
      <Trans i18nKey={translationKey} values={priceArgs} />
    </span>
  );
};

Price.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  priceKey: PropTypes.string,
};
